module.exports = __webpack_public_path__ + "static/media/carousel.dd5bc692.less";